// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import BootstrapVue from 'bootstrap-vue'
// import 'bootstrap/dist/css/bootstrap.css'
import './assets/styles/custom.scss'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import './assets/styles/teal.scss'
import './assets/styles/timeline.scss'
import './assets/styles/unstyled.scss'
// Uncomment the line below  to test otherwise project wont build due to errors
// import './assets/styles/dropdown-fade.scss'

Vue.config.productionTip = false

Vue.use(BootstrapVue)
/* eslint-disable no-new */
Vue.prototype.API_URL = "//mqa.gov.mv/api/v1"

new Vue({
    el: '#app',
    router,
    components: { App },
    template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js